import classNames from 'classnames';
import FormErrorMessage from 'components/FormErrorMessage';
import { FormInput } from 'components/FormInput/FormInput';
import get from 'lodash/get';
import './TextField.css';

const TextField = ({
  autoFocus,
  block,
  disabled,
  disableErrorMessage,
  disableErrorStyle,
  input,
  label,
  id,
  msg,
  meta: { touched, error },
  className,
  password,
  size,
  spaceRight,
  spaceTop,
  style,
  wrapStyle,
  inputRef,
  wrapperClassName = '',
  addon = null,
  preserveErrorSpace,
}) => (
  <div
    style={wrapStyle}
    className={classNames(block ? 'block' : 'inline-block', wrapperClassName)}
  >
    <div className={classNames(addon && 'input-group')}>
      <FormInput
        {...input}
        ref={inputRef}
        autoFocus={autoFocus}
        disabled={disabled}
        id={id}
        className={className}
        hasError={touched && error && !disableErrorStyle}
        placeholder={label}
        type={password ? 'password' : 'text'}
        size={size}
        spaceTop={spaceTop}
        spaceRight={spaceRight}
        style={style}
      />
      {addon}
    </div>
    <div
      className={classNames(
        preserveErrorSpace && 'text-field__error-space-preserver',
      )}
    >
      {touched && !disableErrorMessage && error && (
        <FormErrorMessage>
          {get(msg, ['validation', error], error)}
        </FormErrorMessage>
      )}
    </div>
  </div>
);

export default TextField;
